module.exports = __webpack_public_path__ + "img/_20250528182615-20.ebe56b24.png";